import NbFound from "./NbFound/NbFound";
import { UserFilterPresenter } from "./UserFilter/UserFilter";
import UserListPresenter from "./UserList/UserListPresenter";


export const UserList = {
    List:UserListPresenter,
    NbFoundInfo: NbFound,
    Filter: UserFilterPresenter
}